import * as Roles from '../roles'

export const PROFILE_PERMISSIONS = {
  [Roles.SUPER_ADMIN]: {
    customerDetails: true, // < These three allow for easier grouping,
    marketing: true, // < granular permissions are below if needed in future
    vipInfo: true, // <
    fname: true,
    lname: true,
    address_1: true,
    address_2: true,
    address_3: true,
    city: true,
    postcode: true,
    country: true,
    username: true,
    mobile_number: true,
    home_tel_number: true,
    update: true,
    phoneAllowed: true,
    emailAllowed: true,
    smsAllowed: true,
    postAllowed: true,
    isVip: true
  },
  [Roles.ADMIN]: {
    customerDetails: true, // < These three allow for easier grouping,
    marketing: true, // < granular permissions are below if needed in future
    vipInfo: true,
    fname: true,
    lname: true,
    address_1: true,
    address_2: true,
    address_3: true,
    city: true,
    postcode: true,
    country: true,
    username: true,
    mobile_number: true,
    home_tel_number: true,
    update: true,
    phoneAllowed: true,
    emailAllowed: true,
    smsAllowed: true,
    postAllowed: true,
    isVip: true
  },
  [Roles.EXT_OPS]: {
    customerDetails: true, // < These three allow for easier grouping,
    marketing: false, // < granular permissions are below if needed in future
    vipInfo: true,
    fname: true,
    lname: true,
    address_1: true,
    address_2: true,
    address_3: true,
    city: true,
    postcode: true,
    country: true,
    username: true,
    mobile_number: true,
    home_tel_number: true,
    update: true,
    phoneAllowed: false,
    emailAllowed: false,
    smsAllowed: false,
    postAllowed: false,
    isVip: true
  },
  [Roles.MAINTENANCE]: {
    customerDetails: false, // < These three allow for easier grouping,
    marketing: false, // < granular permissions are below if needed in future
    vipInfo: false,
    fname: false,
    lname: false,
    address_1: false,
    address_2: false,
    address_3: false,
    city: false,
    postcode: false,
    country: false,
    username: false,
    mobile_number: false,
    home_tel_number: false,
    update: false,
    phoneAllowed: false,
    emailAllowed: false,
    smsAllowed: false,
    postAllowed: false,
    isVip: false
  },[Roles.INSURANCE]: {
    customerDetails: false, // < These three allow for easier grouping,
    marketing: false, // < granular permissions are below if needed in future
    vipInfo: false,
    fname: false,
    lname: false,
    address_1: false,
    address_2: false,
    address_3: false,
    city: false,
    postcode: false,
    country: false,
    username: false,
    mobile_number: false,
    home_tel_number: false,
    update: false,
    phoneAllowed: false,
    emailAllowed: false,
    smsAllowed: false,
    postAllowed: false,
    isVip: false
  },
  [Roles.ANALYTICS]: {
    customerDetails: false, // < These three allow for easier grouping,
    marketing: false, // < granular permissions are below if needed in future
    vipInfo: false,
    fname: false,
    lname: false,
    address_1: false,
    address_2: false,
    address_3: false,
    city: false,
    postcode: false,
    country: false,
    username: false,
    mobile_number: false,
    home_tel_number: false,
    update: false,
    phoneAllowed: false,
    emailAllowed: false,
    smsAllowed: false,
    postAllowed: false,
    isVip: false
  }
}
